import type { TenantConfig } from '@/types/TenantConfig'

const navy = '#27548c'

export const usopm: TenantConfig = {
  logo: 'assets/usopm/static/logo.svg',
  themeOptions: {
    primaryColor: navy,
    secondaryColor: navy,
    logoHeight: '110px',
    headerHeight: '150px',
    footerBackgroundColor: '#3B3B3B',
    footerTextColor: 'white',
    cartHeaderBackgroundColor: '#F1F1F1',
    cartHeaderTextColor: 'black',
  },
  teaserImageSize: {
    width: 150,
    height: 150,
  },
  allowedCardBrands: ['visa'],
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700|Open+Sans:400,700&display=swap',
    },
    eventDetailRoute: {
      showVenue: true,
    },
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        percentFees: 'Fee',
      },
      checkoutRoute: {
        title: 'Pay For Your Order',
        cardBrandError: 'Only Visa cards are accepted.',
      },
      selectPaymentMethod: {
        message:
          '<small>In recognition of Visa’s long-standing partnership, the United States Olympic & Paralympic Museum proudly accepts only Visa.</small>',
      },
      accountLinks: {
        loginLinkShortLabel: 'Log In',
        loginLinkLongLabel: 'Member Log In',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
    },
  ],
}
